module.exports = __webpack_public_path__ + "images/a65a8a0.png";